<template>
  <div style="display: flex; justify-content: center">
    <img style="height: 50px" src="../../public/images/Oasis.png" alt="Oasis Streaming" />
  </div>
</template>

<script lang="ts" setup></script>
